export default __webpack_public_path__ + "static/media/bin-icon.915246cc.svg";